import "./style.scss"
const Index = ({ setDeleteTemplateModal, selectedTemplate, setSelectedTemplate, onDelete = () => { }, isLoading, type = null }) => {

    return (
        <div className="small-modal-wrapper">
            <div className="delete-modal-content">
                <div style={{position:'relative', justifyContent:'center', display:'flex', width:'100%'}}>
                <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '0px', top: '0px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
                    setDeleteTemplateModal(false)
                    setSelectedTemplate(null)
                }}></i>
                <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#DC1E00', color: 'var(--white)' }}>
                    <i class="fal fa-trash-alt"></i>
                </span>
                </div>
                <h2>Are you sure?</h2>
                <p>You are about to delete this <strong>{selectedTemplate?.name || '-'}</strong> template {type === 'category' ? 'category' : ''}.</p>
                <button className='btn' disabled={isLoading} onClick={onDelete}>Delete Template {type === 'category' ? 'Category' : ''}</button>
                <button className='btn transparent' onClick={() => {
                    setDeleteTemplateModal(false)
                    setSelectedTemplate(null)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index